import { type CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { type RowInformation } from '../../../../config/flavourConfig';
import { Table, Box, Button } from '@flos/react-ui';
import TableRow from '../../../../shared_components/TableRow/TableRow';
import { getInsuranceSumsShoppingBasketConfig } from '../../utils/ShoppingBasketInsuranceSumsUtil';
import { useHippoText } from '../../../../hooks/useHippoText';
import useWizardNavigation from '../../../../hooks/useWizardNavigation';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { currentCoverableIdAtom } from '../../../../recoil/atoms/currentCoverableIdAtom';
import { isCoverableInsuranceSumsEditable } from '../../../AdjustDetailsPage/config/adjustDetails';
import { useState } from 'react';
import CallMeModal from '../../../../shared_components/CallMeModal/CallMeModal';
import { businessFlowSelector } from '../../../../recoil/selectors/getBusinessFlowSelector';
import { excludedFlavoursSumsConfig } from '../../../../config/excludedFlavorsConfig';
import { IS_OPC_EDIT_AVAILABLE } from '../../../OpcEntryPage/config/OpcConfig';

const ShoppingBasketInsuranceSums = ({
    coverable
}: {
    coverable: CoverableDTO;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const setCurrentCoverableAtom = useSetRecoilState(currentCoverableIdAtom);
    const { wizardGotoStep } = useWizardNavigation();
    const [showCallMeModal, setShowCallMeModal] = useState<boolean>(false);
    const businessFlow = useRecoilValue(businessFlowSelector);

    const componentProperties = getInsuranceSumsShoppingBasketConfig(coverable);
    const coverableProperties = componentProperties?.rowsInformation.filter(
        (rowInfo) => !rowInfo.hidden
    );
    if (!coverableProperties) {
        return <></>;
    }

    const goToAdjustDetailsPage = (): void => {
        if (!isCoverableInsuranceSumsEditable(coverable.lobCode ?? '')) {
            setShowCallMeModal(true);
            return;
        }
        setCurrentCoverableAtom({ fixedId: coverable.fixedId, lobCode: coverable.lobCode });
        wizardGotoStep('AdjustDetailsPage');
    };

    return (
        <>
            <Box className="u-border-none u-shadow-none">
                <div className="u-flex-box u-flex-box--center u-flex-box--space-between u-flex-box--nowrap u-spacing-stack-m">
                    <div className="u-flex-box u-flex-box--space-between">
                        <h4>{getHippoText('DSS-SHOPPING-BASKET-INSURANCE-SUMS-TITLE')}</h4>
                    </div>
                    {businessFlow !== 'ONSA' &&
                        !excludedFlavoursSumsConfig.adjustSums.includes(
                            coverable.flavourName ?? ''
                        ) &&
                        IS_OPC_EDIT_AVAILABLE && (
                            <div className="u-flex-box u-flex-justify-end">
                                <Button onClick={goToAdjustDetailsPage}>
                                    {getHippoText('DSS-SHOPPING-BASKET-ADJUST-COVERABLE')}
                                </Button>
                            </div>
                        )}
                </div>
                <Table mobileDirection="vertical">
                    <Table.Body>
                        {coverableProperties?.map((rowInfo: RowInformation) => {
                            return (
                                <TableRow
                                    rowInfo={rowInfo}
                                    key={rowInfo.name}
                                    shouldAlignTextLeftOnMobile
                                />
                            );
                        })}
                    </Table.Body>
                </Table>
            </Box>
            {showCallMeModal && (
                <CallMeModal
                    activityCode="dss_call_request"
                    showModal={showCallMeModal}
                    closeModal={() => {
                        setShowCallMeModal(false);
                    }}
                />
            )}
        </>
    );
};

export default ShoppingBasketInsuranceSums;
